<template>
  <div class="egl-elm egl-detail setting clearfix">
    <!-- <el-form-item :label="$locale('setting.cinema.pay.payment.shopid')" prop="cinemaSetting.gmoShopId" :rules="formRules.gmoShopId">
      <el-input :placeholder="$locale('setting.cinema.pay.payment.p.shopid')" v-model="detailObj.cinemaSetting.gmoShopId" :disabled="!editable" maxlength="13"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.pay.payment.password')" prop="cinemaSetting.gmoShopPass" :rules="formRules.gmoShopPass">
      <el-input
        :placeholder="$locale('form.plsEnterYourPassword')"
        v-model="detailObj.cinemaSetting.gmoShopPass"
        :disabled="!editable"
        show-password
        autocomplete="new-passwor"
        auto-complete="new-password"
        maxlength="20"
      ></el-input>
    </el-form-item> -->
    <el-form-item :label="$locale('setting.cinema.pay.email')" :prop="`${type}.gmailList[${index}].gmailUserName`" :rules="adminType === 'cinema' ? formRules.gmailUserName : null">
      <el-input :placeholder="$locale('setting.brand.p.email')" v-model="detailObj[type].gmailList[index].gmailUserName" :disabled="!editable" maxlength="50"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.pay.emailpassword')" :prop="`${type}.gmailList[${index}].gmailApiKey`" :rules="adminType === 'cinema' ? formRules.gmailApiKey : null">
      <el-input
        :placeholder="$locale('form.plsEnterYourPassword')"
        v-model="detailObj[type].gmailList[index].gmailApiKey"
        :disabled="!editable"
        show-password
        autocomplete="new-passwor"
        auto-complete="new-password"
        maxlength="20"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.accessToken')" prop="accessToken">
      <el-input
        :placeholder="$locale('form.plsEnterYourPassword')"
        v-model="detailObj[type].gmailList[index].accessToken"
        :disabled="actionType !== 'create'"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.refreshToken')" :prop="`${type}.gmailList[${index}].refreshToken`" :rules="adminType === 'cinema' ? formRules.refreshToken : null">
      <el-input
        :placeholder="$locale('form.plsEnterYourPassword')"
        v-model="detailObj[type].gmailList[index].refreshToken"
        :disabled="!editable"
      ></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "cinemaPaySetting",
  props: {
    detailObj: Object,
    index: Number,
    actionType: String,
    type: String,
    adminType: String
  },
  data() {
    return {
      editable: true,
      action: "create",
      formRules: {
        // gmoShopId: [ {
        //   required: true,
        //   message: this.$locale("setting.cinema.pay.err.shopid"),
        //   trigger: "blur",
        // } ],
        // gmoShopPass: [ {
        //   required: true,
        //   message: this.$locale("setting.cinema.pay.err.password"),
        //   trigger: "blur",
        // } ],
        gmailUserName: [ {
          required: true,
          message: this.$locale("setting.cinema.pay.err.email"),
          trigger: "blur",
        } ],
        gmailApiKey: [ {
          required: true,
          message: this.$locale("setting.cinema.pay.err.emailpassword"),
          trigger: "blur",
        } ],
        refreshToken: [ {
          required: true,
          message: this.$locale("setting.cinema.pay.err.refreshToken"),
          trigger: "blur",
        } ],
      },
    };
  },
  methods: {},
};
</script>
